import React from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Container,
  IconButton
} from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import AppsIcon from '@mui/icons-material/Apps';
import { useNavigate } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import { USER_GROUP } from '../models/types';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';

const Layout = ({ children }) => {
  const { currentUser, logout } = useApp();
  const navigate = useNavigate();

  const getUserDisplayLabel = (user) => {
    if (!user) return '-';
    if (user.group === USER_GROUP.STAFF) {
      const d = user.department;
      if (d === 'water') return 'ประปา';
      if (d === 'electricity') return 'ไฟฟ้า';
      return 'สห.';
    }
    return 'ผู้แจ้ง';
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const isStaff = Boolean(currentUser?.is_staff);
  const canManageMembers = isStaff;

  return (
    <Box
      sx={{
        flexGrow: 1,
        minHeight: '100vh',
        // ทำให้สีพื้นหลังอ่อนลง (pastel) และไม่โปร่งจนเห็นสีพื้นหลังเดิม (กันเป็นสีดำด้านล่าง)
        backgroundColor: '#F9FBFF',
        backgroundImage: 'linear-gradient(to left, rgba(48, 176, 235, 0.09), rgba(132, 94, 194, 0.09))',
        // กัน margin collapse ของลูก (ไม่ให้เกิดพื้นที่ขาวด้านล่าง)
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <AppBar
        position="static"
        elevation={0}
        sx={{
          background: 'linear-gradient(to left , rgb(48, 176, 235), rgba(132, 94, 194, 0.8))',
          backdropFilter: 'blur(10px)',
          boxShadow: 'none',
        }}
      >
        <Toolbar sx={{ py: 2, minHeight: '80px !important', position: 'relative' }}>
          <Box sx={{
            position: { xs: 'static', md: 'absolute' },
            left: { xs: 0, md: '50%' },
            transform: { xs: 'none', md: 'translateX(-50%)' },
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            justifyContent: { xs: 'flex-start', md: 'center' }
          }}>
            <SupportAgentIcon sx={{ fontSize: 40, color: 'rgba(0, 0, 0, 0.6)' }} />
            <Box sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: { xs: 'flex-start', md: 'center' },
              textAlign: { xs: 'left', md: 'center' }
            }}>
              <Typography variant="h6" component="div" sx={{ fontWeight: 600, letterSpacing: 0.5, color: 'rgba(0, 0, 0, 0.6)', textAlign: 'inherit' }}>
              Assist
              <Box component="span" sx={{ display: { xs: 'none', md: 'inline' } }}> System</Box>
              </Typography>
              <Typography
                variant="body1"
                component="div"
                sx={{
                  fontSize: '0.8rem',
                  color: 'rgba(0, 0, 0, 0.6)',
                  textAlign: 'inherit',
                  display: { xs: 'none', md: 'block' }
                }}
              >
                ระบบรับแจ้งปัญหา - ข้อขัดข้องของกองทัพอากาศ
              </Typography>
            </Box>
          </Box>
          <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', gap: 1.5, ml: 'auto' }}>
            <IconButton
              onClick={() => navigate('/select-app')}
              sx={{
                bgcolor: 'rgba(255, 255, 255, 0.25)',
                color: 'rgba(0, 0, 0, 0.7)',
                border: '1px solid rgba(255,255,255,0.35)',
                '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.35)' },
              }}
            >
              <AppsIcon />
            </IconButton>
            <Button
              onClick={handleLogout}
              startIcon={<LogoutIcon />}
              variant="contained"
              sx={{
                display: { xs: 'none', md: 'flex' },
                borderRadius: 1,
                bgcolor: '#845EC2',
                color: 'white',
                fontWeight: 500,
                px: 2,
                '&:hover': {
                  bgcolor: '#6344A4',
                }
              }}
            >
              ออกจากระบบ
            </Button>
          </Box>
          <Box sx={{ display: { xs: 'flex', md: 'none' }, ml: 'auto', gap: 1 }}>
            {canManageMembers && (
              <IconButton
                onClick={() => navigate('/select-app')}
                sx={{
                  bgcolor: 'rgba(255, 255, 255, 0.25)',
                  color: 'rgba(0, 0, 0, 0.7)',
                  border: '1px solid rgba(255,255,255,0.35)',
                  '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.35)' }
                }}
              >
                <AppsIcon />
              </IconButton>
            )}
            <IconButton
              onClick={handleLogout}
              sx={{
                bgcolor: '#845EC2',
                color: 'white',
                '&:hover': {
                  bgcolor: '#6344A4',
                }
              }}
            >
              <LogoutIcon />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>
      <Container
        maxWidth="xl"
        sx={{
          flex: 1,
          // ใช้ padding แทน margin เพื่อไม่ให้พื้นหลัง "ขาด" ด้านล่าง
          py: { xs: 2.5, sm: 4 },
        }}
      >
        {children}
      </Container>
    </Box>
  );
};

export default Layout;
